export const AUTH_API = 'auth-api'
export const ADDRESS_API = 'address-api'
export const POST_API = 'post-api'
export const BRANCH_SCHOOL_API = 'branch-school-api'
export const CATEGORY_API = 'category-api'
export const ACCOUNT_API = 'account-api'
export const NOTIFICATION_API = 'notification-api'
export const REPORT_API = 'report-api'
export const USER_API = 'user-api'
